import { Api } from "@/api";
import { CustomerDocument, Customer as CustomerType } from "@/generated/graphql.lazy/customer.ts";
import { Context } from "@/services/context.ts";

export const CUSTOMER_LISTENER_NAME = "customer";

type UpdateCustomerParams = {
  countryId?: string;
  currency?: string;
  locale?: string;
};

export class Customer {
  constructor(
    protected context: Context,
    protected api: Api,
  ) {}

  protected update = () => {
    this.context.notify(CUSTOMER_LISTENER_NAME);
  };

  updateCustomer = async (params: UpdateCustomerParams) => {
    await this.mutateUpdateCustomer(params);
  };

  protected mutateUpdateCustomer = async (params: UpdateCustomerParams) => {
    const input = structuredClone(params) as Partial<UpdateCustomerParams>;

    const customerResponse = await this.api.client.mutate({
      mutation: CustomerDocument,
      variables: {
        input: {
          countryId: input.countryId,
          currency: input.currency,
          locale: input.locale,
        },
      },
    });

    return customerResponse.data!.Customer as CustomerType;
  };
}
